import { Edit } from "@rsuite/icons";
import { IconButton } from "rsuite";
import { useNavigate } from "react-router-dom";
import { encryptUrl } from "../../../navigation/useDecryptParams";
import { ContentRoutes } from "../../../navigation/NavConstant";

const MediaSingleAction = ({ mediaData, ...props }: { mediaData: any }) => {
  const ecryptedMediaId = encryptUrl(`${mediaData.id}`);

  const mediaUpdateLink = ContentRoutes.UPDATE_MEDIA.replace(
    ":id",
    ecryptedMediaId.toString()
  );

  const navigate = useNavigate();

  function handleEditAction() {
    navigate(`${mediaUpdateLink}`);
  }

  return (
    <div>
      <>
        <IconButton
          appearance="subtle"
          onClick={handleEditAction}
          title={"UPDATE"}
          icon={<Edit />}
        />
      </>
    </div>
  );
};

export default MediaSingleAction;
